<div class="bus-seat">
  <mat-accordion *ngFor="let data of seats">
    <mat-expansion-panel
      hideToggle
      [ngClass]="{ inactive: data.status !== 'Active' }"
      [expanded]="isExpanded"
    >
      <img
        *ngIf="data.status === 'Expired'"
        class="expired-ticket-overlay"
        src="../../../assets/images/expired-ticket.svg"
        alt="expired"
      />
      <mat-expansion-panel-header
        [ngClass]="{ inactive: data.status !== 'Active' }"
      >
        <app-image [fileid]="data.bus.platform.icon" [radius]="8"></app-image>
        <div class="info" style="flex: 1">
          <span class="info1">
            {{ data.bus.platform.name }}
          </span>
          <span class="info2">{{ data.bus.bus_type?.name }}</span>
        </div>
        <!-- <div class="workorder-status" *ngIf="data.work_order_status === 'Repair'">
        正在修复
      </div>
      <div class="workorder-status" *ngIf="data.work_order_status === 'Active'">
        修复完成
      </div> -->
        <div class="info" style="text-align: end">
          <span class="info2">
            <ng-container
              *ngIf="
                data.bus.platform.name !== 'ChatGPT镜像版' &&
                data.bus.platform.name !== 'Midjourney镜像版' &&
                data.bus.platform.name !== 'Grok镜像版'
              "
            >
              车次：{{ data.bus.id }}
            </ng-container>
          </span>
          <span class="info2">
            <ng-container *ngIf="data.status != 'Expired'">
              <ng-container
                *ngIf="
                  data.bus.platform.name !== 'ChatGPT镜像版' &&
                  data.bus.platform.name !== '爆米花' &&
                  data.bus.platform.name !== 'Midjourney镜像版' &&
                  data.bus.platform.name !== 'Grok镜像版'
                "
              >
                座位号：
                <ng-container *ngIf="!data.bus.exclusive; else baoche">{{
                  data.no
                }}</ng-container>
                <ng-template #baoche> 包车 </ng-template>
              </ng-container>
            </ng-container>
          </span>
        </div>
      </mat-expansion-panel-header>
      <div class="detail">
        <!-- <ng-container *ngIf="data.bus.platform.name === 'Netflix'">
          <app-bus-seat-workorder-panel
            [data]="data"
          ></app-bus-seat-workorder-panel>
        </ng-container> -->
        <div
          class="item"
          *ngIf="
            data.bus.bus_type?.group &&
            data.bus.bus_type?.group !== '拼车' &&
            data.bus.bus_type?.group !== '包车'
          "
        >
          <span class="label">类&nbsp;&nbsp;&nbsp;&nbsp;型：</span>
          <span class="value">{{ data.bus.bus_type.group }} </span>
        </div>

        <!-- 判断条件 还得加上这个账号被驳回 -->
        <div
          class="account-error"
          *ngIf="data.status === 'InfoError'"
          (click)="changeAccountError(data)"
        >
          <img src="../../../../assets/images/seat/zhuyi.png" alt="" />
          <span>账号信息有误，点击重新填写</span>
        </div>

        <div
          class="item"
          *ngIf="
            data.status != 'Expired' && data.bus.platform.name === '爆米花'
          "
        >
          <span class="label">兑换码：</span>
          <app-exchange-code
            style="flex: 1; min-width: 0"
            [text]="data.bus.bus_account.username"
            coverText="点击查看兑换码"
          ></app-exchange-code>
        </div>

        <ng-container *ngIf="data.bus.bus_account && data.status != 'Expired'">
          <!-- 工单选择账号也需要隐藏bus_account.username -->
          <ng-container
            *ngIf="
              data.bus.platform.name !== 'ChatGPT镜像版' &&
              data.bus.platform.name !== '爆米花' &&
              data.bus.platform.name !== 'Midjourney镜像版' &&
              data.bus.platform.name !== 'Grok镜像版'
            "
          >
            <div class="item">
              <span class="label">账&nbsp;&nbsp;&nbsp;&nbsp;号：</span>
              <app-account
                style="flex: 1; min-width: 0"
                *ngIf="data.status !== 'Disabled'"
                [text]="data.bus.bus_account.username"
              ></app-account>
              <ng-container *ngIf="data.status === 'Disabled'">
                车票已禁用，请联系客服处理
              </ng-container>
            </div>
            <div class="item" *ngIf="data.status != 'Expired'">
              <span class="label">密&nbsp;&nbsp;&nbsp;&nbsp;码：</span>
              <app-password
                style="flex: 1; min-width: 0"
                [text]="data.bus.bus_account.password"
              ></app-password>
              <ng-container
                *ngIf="
                  data.bus.platform.name === 'Netflix' &&
                  (data.status === 'Active' || data.status === 'Repair')
                "
              >
                <span style="color: #b61111">*不要频繁登陆</span>
              </ng-container>
            </div>
            <div
              class="item"
              *ngIf="
                data.bus.bus_account.password_question &&
                data.status != 'Expired'
              "
            >
              <span class="label">密&nbsp;&nbsp;&nbsp;&nbsp;保：</span>
              <app-password
                style="flex: 1; min-width: 0"
                [text]="data.bus.bus_account.password_question"
                coverText="点击查看密保"
              ></app-password>
            </div>
          </ng-container>
        </ng-container>

        <ng-container
          *ngIf="
            !data.bus.bus_account &&
            (data.bus.bus_type.username_submit ||
              data.bus.bus_type.password_submit) &&
            data.status != 'Expired'
          "
        >
          <div class="item">
            <span class="label">账&nbsp;&nbsp;&nbsp;&nbsp;号：</span>
            <app-account
              [text]="data.user_username"
              style="flex: 1; min-width: 0"
            ></app-account>
          </div>
          <div class="item">
            <span class="label">密&nbsp;&nbsp;&nbsp;&nbsp;码：</span>
            <app-password
              [text]="data.user_password"
              style="flex: 1; min-width: 0"
            ></app-password>
          </div>
        </ng-container>
        <ng-container
          *ngIf="
            data.bus.delivery_method === 'Invitation' &&
            data.status != 'Expired'
          "
        >
          <div class="item">
            <span class="label">邀请链接：</span>
            <app-bus-account-invitation-link-label
              style="flex: 1"
              [id]="data.invitation_link_id"
              *ngIf="data.invitation_link_id"
            ></app-bus-account-invitation-link-label>
          </div>
        </ng-container>
        <div class="item">
          <span class="label">有效期：</span>
          <span style="display: flex; align-items: center">
            <app-datetime [text]="data.ended_time"></app-datetime>
            <app-days-countdown
              *ngIf="data.status != 'Expired' && data.status !== 'Inactive'"
              [days]="data.remaining_days"
            ></app-days-countdown>
          </span>
        </div>
        <div class="item" *ngIf="data.status != 'Expired'">
          <span class="label">状&nbsp;&nbsp;&nbsp;&nbsp;态：</span>
          <app-bus-seat-status
            *ngIf="!data.status_youtube"
            [status]="data.status"
          ></app-bus-seat-status>
          <app-bus-seat-status-repair
            *ngIf="data.status_youtube"
            [data]="data"
          ></app-bus-seat-status-repair>
        </div>
        <ng-container
          *ngIf="
            (data.bus.platform.name === 'Adobe' ||
              data.bus.platform.name === 'Netflix' ||
              data.bus.platform.name === 'PS AI' ||
              data.bus.platform.name === 'ChatGPT Plus' ||
              data.bus.platform.name === 'ChatGPT' ||
              data.bus.platform.name === 'Suno国际版' ||
              data.bus.platform.name === 'Spotify' ||
              data.bus.platform.name === 'Disney+' ||
              data.bus.platform.name === 'ChatGPT Go') &&
            (data.status === 'Active' || data.status === 'Repair')
          "
        >
          <div class="item">
            <span class="label">验证码：</span>
            <app-verification-code
              *ngIf="
                !data.bus.bus_account?.initial_verify ||
                data.bus.platform.name === 'Adobe'
              "
              [data]="data"
              [platform]="data.bus.platform.name"
            ></app-verification-code>
            <app-verification-code-new
              *ngIf="
                data.bus.bus_account?.initial_verify &&
                data.bus.platform.name !== 'Adobe'
              "
              [data]="data"
              [platform]="data.bus.platform.name"
            ></app-verification-code-new>
          </div>
        </ng-container>
        <!-- 补偿时间 -->
        <ng-container
          *ngIf="
            data.bus.platform.name === 'YouTube' &&
            (data.status === 'Active' || data.status === 'Repair')
          "
        >
          <app-repair-time-label [data]="data"></app-repair-time-label>
        </ng-container>
        <ng-container
          *ngIf="
            data.bus.platform.name === 'ChatGPT镜像版' &&
            (data.status === 'Active' || data.status === 'Repair')
          "
        >
          <div class="fleet-package" (click)="openFleetPackage()">
            套餐次数说明
          </div>
          <div class="fleet" [routerLink]="['/user/profile/fleet']">
            查看车队
          </div>
        </ng-container>
        <ng-container
          *ngIf="
            data.bus.platform.name === 'Grok镜像版' &&
            (data.status === 'Active' || data.status === 'Repair')
          "
        >
          <div class="fleet-package" (click)="openFleetPackage()">
            套餐次数说明
          </div>
          <div class="fleet" [routerLink]="['/user/profile/grok']">
            查看车队
          </div>
        </ng-container>
        <ng-container
          *ngIf="
            data.bus.platform.name === 'UniverSal Node' &&
            (data.status === 'Active' || data.status === 'Repair')
          "
        >
          <a
            class="fleet node-exchange"
            href="https://node.universalbus.cn/"
            target="_blank"
          >
            前往兑换
          </a>
        </ng-container>
        <ng-container *ngIf="data.bus.platform.name === '爆米花'">
          <div
            class="fleet"
            style="margin-top: 20px"
            (click)="goto(data.bus.platform.name)"
          >
            前往兑换
          </div>
        </ng-container>
        <ng-container *ngIf="data.bus.platform.name === '借个号'">
          <div
            class="fleet"
            style="margin-top: 20px"
            (click)="goto(data.bus.platform.name)"
          >
            前往借个号
          </div>
        </ng-container>
        <ng-container *ngIf="data.bus.platform.name === 'Gemini'">
          <div class="fleet" style="margin-top: 20px" (click)="openGeminiTip()">
            查看养号教程
          </div>
        </ng-container>
        <!-- mj -->
        <ng-container
          *ngIf="
            data.bus.platform.name === 'Midjourney镜像版' &&
            (data.status === 'Active' || data.status === 'Repair')
          "
        >
          <!-- <div class="fleet-package" (click)="openFleetPackage()">
            套餐次数说明
          </div> -->
          <div
            class="fleet"
            [routerLink]="['/midjourney']"
            style="margin-top: 20px"
          >
            开始绘画
          </div>
        </ng-container>
        <!-- <div
          class="link"
          *ngIf="
            data.bus.platform.name === 'Netflix' &&
            (data.status === 'Active' || data.status === 'Repair')
          "
        >
          <app-verification-code-panel
            [data]="data"
          ></app-verification-code-panel>
        </div> -->
        <div
          class="link"
          *ngIf="
            data.bus.bus_account?.password_question_2 &&
            data.status != 'Expired'
          "
        >
          <!-- <app-adobe-panel [data]="data"></app-adobe-panel> -->
          <img
            src="../../../assets/images/Icon-link.svg"
            alt="link"
            width="20"
            height="20"
            style="padding: 0"
          />
          <a
            style="
              margin-left: 10px;
              cursor: pointer;
              font-size: 16px;
              color: var(--primary-color);
              text-decoration-line: underline;
            "
            [href]="data.bus.bus_account.password_question_2"
            target="_blank"
            >前往接收验证码</a
          >
        </div>

        <!-- <div
          class="link"
          style="display: flex; align-items: center"
          *ngIf="data?.bus?.bus_type?.id === 281"
        >
          <img
            src="../../../assets/images/Icon-link.svg"
            alt="link"
            width="20"
            height="20"
            style="padding: 0"
          />
          <a
            style="
              margin-left: 10px;
              cursor: pointer;
              font-size: 16px;
              color: var(--primary-color);
              text-decoration-line: underline;
            "
            href="https://quickplus.vip/public/grok/"
            target="_blank"
            >前往自助充值</a
          >
        </div> -->
        <!-- <ng-container *ngIf="data?.bus?.bus_type?.id === 216">
          <div class="link" style="display: flex; align-items: center">
            <img
              src="../../../assets/images/Icon-link.svg"
              alt="link"
              width="20"
              height="20"
              style="padding: 0"
            />
            <a
              style="
                margin-left: 10px;
                cursor: pointer;
                font-size: 16px;
                color: var(--primary-color);
                text-decoration-line: underline;
              "
              href="https://bayue.ai/"
              target="_blank"
              >前往自助充值</a
            >
          </div>
          <div class="link" style="display: none; align-items: center">
            <img
              src="../../../assets/images/Icon-link.svg"
              alt="link"
              width="20"
              height="20"
              style="padding: 0"
            />
            <a
              style="
                margin-left: 10px;
                cursor: pointer;
                font-size: 16px;
                color: var(--primary-color);
                text-decoration-line: underline;
              "
              href="https://chongzhi.pro/"
              target="_blank"
              >备用充值渠道</a
            >
          </div>
        </ng-container> -->
        <!-- <div
          class="link"
          style="display: flex; align-items: center"
          *ngIf="data.bus.platform.name === 'Claude'"
        >
          <img
            src="../../../assets/images/Icon-link.svg"
            alt="link"
            width="20"
            height="20"
            style="padding: 0"
          />
          <a
            style="
              margin-left: 10px;
              cursor: pointer;
              font-size: 16px;
              color: var(--primary-color);
              text-decoration-line: underline;
            "
            href="https://quickplus.vip/"
            target="_blank"
            >前往自助充值
          </a>
        </div> -->
        <div
          class="link"
          style="display: flex; align-items: center"
          *ngIf="data.bus?.bus_account?.recharge_address"
        >
          <img
            src="../../../assets/images/Icon-link.svg"
            alt="link"
            width="20"
            height="20"
            style="padding: 0"
          />
          <a
            style="
              margin-left: 10px;
              cursor: pointer;
              font-size: 16px;
              color: var(--primary-color);
              text-decoration-line: underline;
            "
            [href]="data.bus.bus_account.recharge_address"
            target="_blank"
            >前往自助充值
          </a>
        </div>
        <!-- <div
          class="compensate"
          (click)="openCompensateAdobe(data)"
          *ngIf="
            data.bus.platform.name === 'Adobe' &&
            (data.bus.bus_type_id === 150 || data.bus.bus_type_id === 151) &&
            (data.status === 'Active' || data.status === 'Repair')
          "
        >
          <img
            src="../../../../assets/images/compensate/Icon-compensate.webp"
            alt=""
          />
          <span>立即选择处理方案</span>
        </div> -->
        <!-- <div
          class="compensate"
          (click)="openCompensateNetflix(data)"
          *ngIf="
            data.bus.platform.name === 'Netflix' &&
            (data.status === 'Active' || data.status === 'Repair')
          "
        >
          <img
            src="../../../../assets/images/compensate/Icon-compensate.webp"
            alt=""
          />
          <span>若账号无法观看，请点击选择解决方案</span>
        </div> -->
        <div
          class="compensate"
          (click)="openCompensateYoutube(data)"
          *ngIf="
            data.bus.platform.name === 'YouTube' &&
            data.bus.bus_type.group !== '个人会员' &&
            (data.status === 'Active' || data.status === 'Repair')
          "
        >
          <img
            src="../../../../assets/images/compensate/Icon-compensate.webp"
            alt=""
          />
          <span>若账号出现广告，请点击选择解决方案</span>
        </div>
      </div>
      <div class="divider"></div>
      <div class="action">
        <!-- <ng-container
            *ngIf="
              data.bus.platform.name !== 'ChatGPT镜像版' &&
              data.bus.platform.name !== '爆米花'
            "
          >
            <button
              mat-flat-button
              class="view"
              (click)="openPassager(data)"
              *ngIf="data.status != 'Expired'"
            >
              <mat-icon>visibility</mat-icon> 查看车友
            </button>
          </ng-container> -->
        <!-- <button
          mat-flat-button
          class="view"
          (click)="openAiCustomerService()"
          *ngIf="
            !(data.status === 'Expired' && data.bus.platform.name !== 'YouTube')
          "
        >
          <mat-icon>post_add</mat-icon> AI客服
        </button> -->
        <button
          mat-flat-button
          class="view"
          (click)="openWorkorder(data)"
          *ngIf="
            !(data.status === 'Expired' && data.bus.platform.name !== 'YouTube')
          "
        >
          <mat-icon>post_add</mat-icon> 新建工单
        </button>
        <!-- <button mat-flat-button class="service" (click)="openService()">
            <mat-icon>support_agent</mat-icon> 联系客服
          </button> -->
        <div class="spacer"></div>
        <button
          mat-flat-button
          [ngClass]="{ expired: data.status === 'Expired' }"
          class="renew"
          (click)="renew(data)"
          *ngIf="
            data.bus.bus_type?.status === 'Showing' &&
            data.bus.bus_type.renewable &&
            (!data.bus.bus_account || data.bus.bus_account.status === 'Online')
          "
        >
          <ng-container *ngIf="data.status != 'Expired'">续费</ng-container>
          <ng-container *ngIf="data.status === 'Expired'"
            >再次购买</ng-container
          >
        </button>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>
<div class="placeholder" *ngIf="!loading && seats.length === 0">
  <h1>您还未购买车票、或车票已经到期</h1>
  <h2>官方自营、即买即用、售后保障、客服全天在线</h2>
  <button mat-raised-button color="primary" routerLink="/buy">
    <span>前往购买</span>
    <mat-icon>arrow_forward</mat-icon>
  </button>
</div>
<mat-spinner *ngIf="loading" [diameter]="60"></mat-spinner>
